export type UiDensity = "default" | "compact";

const ONBOARDING_KEY = "dds-onboarding-seen-v1";
const DENSITY_KEY = "dds-ui-density-v1";

export function hasSeenOnboardingTour(): boolean {
  return localStorage.getItem(ONBOARDING_KEY) === "1";
}

export function markOnboardingTourSeen() {
  localStorage.setItem(ONBOARDING_KEY, "1");
}

export function resetOnboardingTourSeen() {
  localStorage.removeItem(ONBOARDING_KEY);
}

export function getUiDensity(): UiDensity {
  return localStorage.getItem(DENSITY_KEY) === "compact" ? "compact" : "default";
}

export function setUiDensity(density: UiDensity) {
  localStorage.setItem(DENSITY_KEY, density);
}
